// extracted by mini-css-extract-plugin
export default {"mainCont":"TemplateActivate_mainCont__YZgZs","errCont":"TemplateActivate_errCont__20BOp","actCont":"TemplateActivate_actCont__Wq30Z","btnCont":"TemplateActivate_btnCont__Zuutr"};